import produce from "immer";
import moment from "moment";
import {
  ActionType,
  ClearSearchTermAction,
  HandleRecentSearchTermClickAction,
  ResetFiltersAction,
  SortByText,
  StatusFilter,
  UpdateEndDateAction,
  UpdatePageAction,
  UpdateSearchTermAction,
  UpdateServerSearchTermAction,
  UpdateSortByTextAction,
  UpdateStartDateAction,
  UpdateStatusFilterTextAction,
} from "search/actions";

export interface SearchState {
  clientSearchTerm: string;
  endDate: moment.Moment | null;
  page: number;
  serverSearchTerm: string;
  sortByText: SortByText;
  startDate: moment.Moment | null;
  statusFilterText: StatusFilter;
}

export type AllSearchActions =
  | ClearSearchTermAction
  | HandleRecentSearchTermClickAction
  | ResetFiltersAction
  | UpdateEndDateAction
  | UpdatePageAction
  | UpdateSearchTermAction
  | UpdateServerSearchTermAction
  | UpdateSortByTextAction
  | UpdateStartDateAction
  | UpdateStatusFilterTextAction;

export const initialSearchState = {
  clientSearchTerm: "",
  endDate: null,
  page: 0,
  serverSearchTerm: "",
  sortByText: SortByText.MostRelevant,
  startDate: null,
  statusFilterText: StatusFilter.AllResults,
};

export const searchReducer = (
  state: SearchState = initialSearchState,
  action: AllSearchActions,
) => {
  return produce(state, draft => {
    switch (action.type) {
      case ActionType.ClearSearchTerm:
        draft.clientSearchTerm = "";
        draft.serverSearchTerm = "";
        break;

      case ActionType.UpdateClientSearchTerm:
        draft.clientSearchTerm = action.payload.clientSearchTerm;
        break;

      case ActionType.UpdateStartDate:
        draft.startDate = action.payload.startDate;
        break;

      case ActionType.UpdateEndDate:
        draft.endDate = action.payload.endDate;
        break;

      case ActionType.UpdatePage:
        draft.page = action.payload.page;
        break;

      case ActionType.UpdateStatusFilterText:
        draft.statusFilterText = action.payload.statusFilter;
        break;

      case ActionType.UpdateSortByText:
        draft.sortByText = action.payload.sortByText;
        break;

      case ActionType.UpdateServerSearchTerm:
        draft.serverSearchTerm = action.payload.serverSearchTerm;
        break;

      case ActionType.ResetFilters:
        draft.endDate = initialSearchState.endDate;
        draft.page = initialSearchState.page;
        draft.sortByText = initialSearchState.sortByText;
        draft.startDate = initialSearchState.startDate;
        draft.statusFilterText = initialSearchState.statusFilterText;
        break;

      case ActionType.HandleRecentSearchTermClick: {
        const { searchTerm } = action.payload;
        draft.clientSearchTerm = searchTerm;
        draft.serverSearchTerm = searchTerm;
        break;
      }

      default: {
        break;
      }
    }
  });
};
